<template lang="pug">
box
  page-title(slot="page-title", title="Histórico de Documentos")
  load-manager.scrollable(slot="content", :loading="loading", :errors="errors")
    .container.grid-lg.pt-2
      table.table.table-striped.table-hover
        thead
          tr
            th Número
            th Cadastro
            th Emitido em
            th Situação
            th.text-right Valor total
            th(width="80px")
        tbody
          tr(v-for="doc in docs")
            td {{ doc.numero }} / {{ doc.ano }}
            td {{ doc.cadastro ? doc.cadastro.numero : "-" }}
            td {{ doc.created_at | date }}
            td {{ doc.situacao.descricao }}
            td.text-right {{ doc.valor_total | currency("R$ ") }}
            td.text-right.actions-col
              .actions
                router-link.tooltip.tooltip-left(
                  :data-tooltip="'views.buttons.show.label' | translate",
                  :to="`/app/docs/${doc.id}`"
                )
                  i.fa.fa-eye.fa-lg
</template>

<script>
import showMixin from "@/mixins/show";

export default {
  vuex: {
    cadastros: {
      actions: ["fetchOne", "fetchDocs"],
      getters: ["loading"],
      state: ["current", "docs"],
    },
  },
  mixins: [showMixin],
  async created() {
    const { id } = this.$route.params;
    if (this.docs.length === 0) {
      try {
        await this.fetchDocs(id);
      } catch (e) {
        this.addErrors(parseErrors(e));
        toastErrors(e);
      }
    }
  },
};
</script>
